import type { RefObject } from 'react';
import type { HeadingRef } from 'components/atoms/heading/Heading.data';
import type { TextRef } from 'components/atoms/text/Text.data';
import { findTransitionController } from 'util/core-transition-component';

interface StoryCardRefs {
  elementRef: RefObject<HTMLElement>;
  titleRef: RefObject<HeadingRef | null>;
  descriptionRef: RefObject<TextRef | null>;
  imageRef: RefObject<HTMLImageElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef, imageRef }: StoryCardRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const descriptionController = findTransitionController(descriptionRef);

  if (imageRef) {
    timeline.fromTo(imageRef.current, { scale: 1.15 }, { scale: 1, duration: 0.6 }, 0);
  }

  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (descriptionController) {
    timeline.add(descriptionController.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef, imageRef }: StoryCardRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const descriptionController = findTransitionController(descriptionRef);

  if (imageRef) {
    timeline.to(imageRef.current, { scale: 1.15 }, 0);
  }

  if (titleController) {
    timeline.add(titleController.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (descriptionController) {
    timeline.add(descriptionController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
